<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import gql from 'graphql-tag';
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'nav-data-source',
    mixins: [baseOption],

    apollo: {
        navItems: {
            query: gql`
                {
                    item(path: "/sitecore/content/Navigation") {
                        children {
                            id
                            name
                        }
                    }
                }
            `,
            update(data) {
                return data.item.children;
            },
        },
    },

    data() {
        return {
            displayName: 'Data Source',
            message: '* A data source must be selected from items in /sitecore/content/Navigation',
            value: '',
        };
    },

    computed: {
        options() {
            const noneOption = { text: 'None', value: '' };

            if (!this.navItems) return [noneOption];

            return [
                noneOption,
                ...this.navItems.map(nav => ({ text: nav.name, value: nav.id })),
            ];
        },
    },

    watch: {
        navItems() {
            if (!this.navItems) return;

            this.onSelectedElement();
        },
    },

    methods: {
        async onInput(valueNew) {
            this.value = valueNew;
            this.selectedElements.forEach(elem => elem.setElementData('nav-data-source', valueNew));
        },

        onSelectedElement() {
            this.value = this.selectedElements[0].getElementData('nav-data-source') || '';
        },
    },
};
</script>
